module.exports = __webpack_public_path__ + "img/logo_pixeon.85ff2f1d.png";